import deTranslations from './de/de'
import enTranslations from './en/en'
import esTranslations from './es/es'
import frTranslations from './fr/fr'
import itTranslations from './it/it'
import nlTranslations from './nl/nl'

const translations: any = {
  de: deTranslations,
  en: enTranslations,
  es: esTranslations,
  fr: frTranslations,
  it: itTranslations,
  nl: nlTranslations
}

export default translations
